import Form from 'react-bootstrap/Form';

function AdminInformationSection({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  edit = false,
}) {
  return (
    <>
      <Form.Group controlId='firstName' className='mt-2'>
        <Form.Label>Förnamn</Form.Label>
        <Form.Control
          type='text'
          value={values?.firstName}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='Ange förnamn'
          isInvalid={!!errors?.firstName}
        />
        <Form.Control.Feedback type='invalid'>
          {errors?.firstName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId='lastName' className='mt-2'>
        <Form.Label>Efternamn</Form.Label>
        <Form.Control
          type='text'
          value={values?.lastName}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='Ange efternamn'
          isInvalid={!!errors?.lastName}
        />
        <Form.Control.Feedback type='invalid'>
          {errors?.lastName}
        </Form.Control.Feedback>
      </Form.Group>
      {!edit ? (
        <>
          <Form.Group controlId='email' className='mt-2'>
            <Form.Label>E-post</Form.Label>
            <Form.Control
              type='email'
              value={values?.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder='Ange e-post'
              isInvalid={!!errors?.email}
            />
            <Form.Control.Feedback type='invalid'>
              {errors?.email}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId='password' className='mt-2'>
            <Form.Label>Lösenord</Form.Label>
            <Form.Control
              type='password'
              value={values?.password}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder='Ange lösenord'
              isInvalid={!!errors?.password}
            />
            <Form.Control.Feedback type='invalid'>
              {errors?.password}
            </Form.Control.Feedback>
          </Form.Group>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default AdminInformationSection;
